import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../../utils/pagination";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import VendorDrawer from "../../../../common_components/vendor_module_drawer";
import { getVendorWorkOrderList_action, deleteVendorWorkOrder_action } from "../../../../actions/admin_module_action/vendor_action/vendorWorkOrder_action/vendorWorkOrder_action";
import { exhibitionId, serviceTypeId, toastError, toastSuccess } from "../../../../utils/constants";
import Select from 'react-select';
import Modal from "react-modal";

const styles = {
    width: '100%',
};

class VendorWorkOrderList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            workOrderList: [],
            currentPage: 1,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            exhibitionList: [],
            WorkOrderNumber: '',
            PersonName: '',
            ServiceID: [],
            serviceTypeList: [],
            Status: '',
            EmailID: '',
            WorkOrderServiceList: [],
            workOrderList: [],
            isOpen: false,
            sortField: '',
            sortOrder: '',
            isVendor: JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17,
            showVideoModal: false,
            loginAccesslist: []
        }
        this.updateItem = this.updateItem.bind(this)
    }

    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        this.getFillList(exhibitionId, '', '', '', '', '');
        this.getFillList(serviceTypeId, '', '', '', '', '');
        this.getWorkOrderList()
    }

    getWorkOrderList() {
        const { ExhibitionID, WorkOrderNumber, ServiceID, PersonName, EmailID, Status } = this.state
        this.setState({ isLoading: true })
        const servicesids = ServiceID.map(item => item.value).join(",")
        try {
            this.props.getVendorWorkOrderList_action(ExhibitionID, WorkOrderNumber, servicesids, PersonName, EmailID, Status != '' ? Status : null)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ workOrderList: data.data })
                    } else {
                        toastError(data.msg)
                    }
                    this.setState({ isLoading: false })
                })
                .catch((err) => {
                    console.log(err)
                })

        } catch {
            toastError("Something went wrong!")
            this.setState({ isLoading: false })
        }
    }

    deleteWorkOrder() {
        const { WorkOrderID, ExhibitionID, } = this.state
        this.setState({ isLoading: true })
        try {
            this.props.deleteVendorWorkOrder_action(WorkOrderID, ExhibitionID)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isOpen: false })
                        this.clearValue()
                        toastSuccess("Deleted successfully!")
                    } else {
                        toastError(data.msg)
                    }
                    this.setState({ isLoading: false })
                })
                .catch((err) => {
                    console.log(err)
                })

        } catch {
            toastError("Something went wrong!")
            this.setState({ isLoading: false })
        }
    }

    updateItem(item) {
        const { workOrderList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = workOrderList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(workOrderList.length / recordsPerPage)
    }

    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
            .then((data) => {
                if (data.error != 1) {
                    // voucher list
                    if (actionID === exhibitionId) {
                        // console.log("voucher type data", data.data)
                        this.setState({
                            exhibitionList: data.data, isLoading: false,
                        })
                    }
                    if (actionID === serviceTypeId) {
                        this.setState({ WorkOrderServiceList: data.data });
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    addWorkOrder() {
        this.props.navigate('/vendorWorkOrderAU', { state: { add: true } })
    }

    updateWorkOrder(WorkOrderID, param) {
        if (param == 'replicate') {
            this.props.navigate('/vendorWorkOrderAU', { state: { update: true, isView: false, replicate: true, WorkOrderID: WorkOrderID } })
        } else if (param == 'view') {
            this.props.navigate('/vendorWorkOrderAU', { state: { update: true, isView: true, replicate: false, WorkOrderID: WorkOrderID } })
        } else {
            this.props.navigate('/vendorWorkOrderAU', { state: { update: true, isView: false, replicate: false, WorkOrderID: WorkOrderID } })
        }
    }

    clearValue() {
        this.setState({
            ExhibitionID: '',
            WorkOrderNumber: '',
            PersonName: '',
            ServiceID: [],
            EmailID: '',
            Status: '',
        })

        setTimeout(() => {
            this.getWorkOrderList()
        }, 100);
    }

    handleSort = (field) => {
        const { sortField, sortOrder, workOrderList } = this.state;
        const newSortOrder = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';

        const sortedData = [...workOrderList].sort((a, b) => {
            const aVal = a[field];
            const bVal = b[field];

            // Handle numbers vs strings
            if (typeof aVal === 'number' && typeof bVal === 'number') {
                return newSortOrder === 'asc' ? aVal - bVal : bVal - aVal;
            }

            const aStr = (aVal || '').toString().toLowerCase();
            const bStr = (bVal || '').toString().toLowerCase();;

            if (aStr < bStr) return newSortOrder === 'asc' ? -1 : 1;
            if (aStr > bStr) return newSortOrder === 'asc' ? 1 : -1;
            return 0;
        });

        this.setState({ workOrderList: sortedData, sortField: field, sortOrder: newSortOrder });
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '82');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '82');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '82');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    getDownloadAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '82');
        if (moduleAccess) {
            return moduleAccess.DownloadAccess;
        } else {
            return false
        }
        return false;
    }

    getSendAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '82');
        if (moduleAccess) {
            return moduleAccess.SendAccess;
        } else {
            return false
        }
        return false;
    }


    getSpecialAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '82');
        if (moduleAccess) {
            return moduleAccess.Is_SpecialAccess;
        } else {
            return false
        }
        return false;
    }

    render() {
        const { isLoading, ExhibitionID, WorkOrderNumber, PersonName, ServiceID, currentPage, exhibitionList, EmailID, Status, WorkOrderServiceList, workOrderList, isOpen, isVendor, showVideoModal } = this.state

        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = isVendor ? workOrderList : workOrderList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(workOrderList.length / recordsPerPage)
        var moreActions = 1
        currentRecords.map(data => {
            if (data.IsActive && this.getWriteAccess()) {
                moreActions = 2
                // edit
                if (!isVendor) {
                    moreActions = 3
                    //  replicate and delete
                }
            }
        })
        console.log("currentRecords", currentRecords)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {isVendor && showVideoModal && (
                    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => this.setState({ showVideoModal: false })}>
                        <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Scope of Work</h5>
                                    <button type="button" className="btn-close" onClick={() => this.setState({ showVideoModal: false })}></button>
                                </div>
                                <div className="modal-body">
                                    <video controls autoPlay style={{ width: '100%' }}>
                                        <source src="/assets/VendorSOW.mp4" type="video/mp4" />
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {
                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                        <ExhibitorHeader /> : <HeaderWithLogo />
                }
                <div className={JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ? "with-dr-container" : "with-dr-container com-height"}
                    style={{ margin: isVendor ? 0 : '' }}
                >
                    {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID !== 7 && JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID !== 17) && (
                        <div class="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Scope of work List</h6>
                            </div>
                        </div>
                    )}
                    <div class="main-content admin-top-space">

                        {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                                <ExhibitorDrawer /> :
                                (JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17) ?
                                    <VendorDrawer /> : <AdminDrawer />
                        }
                        {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                                <ExhibitorTopMenu /> : null
                        }
                        {isVendor && (
                            <div className="d-flex justify-content-end p-3 pb-1">
                                {/* <span
                                    onClick={() => this.setState({ showVideoModal: true })}
                                    style={{ cursor: 'pointer', color: '#3dbca7', fontSize: '16px' }}
                                >
                                    <i className="bi bi-play-circle-fill me-2"></i>User Manual
                                </span> */}
                            </div>
                        )}

                        {!isVendor && <div class="row mt-1 pb-0 p-2 m-0">
                            <div className="col-md-3">
                                <label>Exhibition</label>
                                <select
                                    className="form-control"
                                    id="roledb"
                                    // style={{ textAlign: "left" }}
                                    value={ExhibitionID}
                                    onChange={(e) => this.setState({ ExhibitionID: e.target.value })}
                                >
                                    <option>Select</option>
                                    {exhibitionList.length > 0 && exhibitionList.map((data) => (
                                        <option key={data.ExhibitionID
                                        } value={data.ExhibitionID
                                        }>{data.ExhibitionName}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-xl-3 mb-3">
                                <label>Work Order Number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    defaultValue=""
                                    required=""
                                    value={WorkOrderNumber}
                                    onChange={(e) => this.setState({ WorkOrderNumber: e.target.value })}
                                />
                            </div>
                            <div className="col-xl-6 mb-3">
                                <label>Services</label>
                                <Select className='text-left'
                                    options={WorkOrderServiceList.map((option) => ({ label: option.Name, value: option.ServiceID }))}
                                    value={ServiceID}
                                    onChange={(e) => this.setState({ ServiceID: e })}
                                    isMulti
                                />
                            </div>
                            <div className="col-xl-3 mb-3">
                                <label>Person Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    defaultValue=""
                                    required=""
                                    value={PersonName}
                                    onChange={(e) => this.setState({ PersonName: e.target.value })}
                                />
                            </div>
                            <div className="col-xl-3 mb-3">
                                <label>
                                    Email ID</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    defaultValue=""
                                    required=""
                                    value={EmailID}
                                    onChange={(e) => this.setState({ EmailID: e.target.value })}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Status</label>
                                <select
                                    className="form-control"
                                    id="roledb"
                                    value={Status}
                                    onChange={e => this.setState({
                                        Status: e.target.value
                                    })}

                                >
                                    <option value={''}>Select</option>
                                    <option value={'Draft'}>Draft</option>
                                    <option value={'Submitted'}>Submitted</option>
                                    <option value={'Deleted'}>Deleted</option>
                                </select>
                            </div>
                            {/* <div className="col-md-3">
                                <label>Service Type</label>
                                <select
                                    className="form-control"
                                    id="roledb"
                                    // style={{ textAlign: "left" }}
                                    value={ServiceID}
                                    onChange={(e) => this.setState({ ServiceID: e.target.value })}
                                >
                                    <option>Select</option>
                                    {serviceTypeList.length > 0 && serviceTypeList.map((data) => (
                                        <option key={data.ServiceID
                                        } value={data.ServiceID
                                        }>{data.Name}</option>
                                    ))}
                                </select>
                            </div> */}
                        </div>}

                        {!isVendor && <div className="row">
                            <div className="col-md-12">
                                <div
                                    className="mb-1"
                                    role="group"
                                    aria-label="Basic example"
                                    style={{ float: "right" }}
                                >
                                    <button type="button" className="btn btn-aqua mx-2"
                                        onClick={e => this.getWorkOrderList()}
                                    >
                                        Search
                                    </button>
                                    <button type="button" className="btn btn-gray"
                                        onClick={e => this.clearValue()}
                                    >
                                        Clear
                                    </button>
                                    <button type="button" className="btn btn-aqua mx-2"
                                        disabled={!this.getWriteAccess()}
                                        onClick={() => this.addWorkOrder()}
                                    >
                                        Add Scope of work
                                    </button>
                                </div>
                            </div>
                        </div>
                        }
                        <div className="row mx-2 pe-2 m-0">
                            <div
                                className="table-responsive px-1 sticky-table-wrapper service-list-grid mt-2 mx-2"
                                style={{ position: "relative", zIndex: 0 }}
                            >
                                <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                                    <thead class="table-light">
                                        <tr>
                                            <th>Work Order Number</th>
                                            <th>Services</th>
                                            <th>Service Partner</th>
                                            <th>Person Name</th>
                                            <th>Email ID</th>
                                            <th>Mobile Number</th>
                                            <th>Start-End Date</th>
                                            <th>Status</th>
                                            <th className="text-left" style={{ width: '10px' }}>{moreActions == 1 ? 'View' : moreActions == 2 ? 'View/Edit' : moreActions == 3 ? 'View/Edit/Replicate/Delete' : ''}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            currentRecords.length > 0 && currentRecords != null ?
                                                currentRecords.map((data, i) => (
                                                    <tr>
                                                        <td className="text-aqua" style={{ cursor: 'pointer' }}
                                                            onClick={() => this.getUpdateAccess() && this.updateWorkOrder(data.WorkOrderID, 'update')}
                                                        >{data.WorkOrderNumber || '-'}</td>
                                                        <td>{data.WorkOrderServices || '-'}</td>
                                                        <td>{data.VendorCompanyName || '-'}</td>
                                                        <td>{data.PersonName || '-'}</td>
                                                        <td>{data.EmailID || '-'}</td>
                                                        <td>{data.MobileNumber || '-'}</td>
                                                        <td>{data.StartEndDate || '-'}</td>
                                                        <td className={data.StatusName == "Draft" ? "text-warning" : data.StatusName == "Submitted" ? "text-success" : "text-danger"}>{data.StatusName}</td>
                                                        <td className="text-left act-col">
                                                            {<a>
                                                                <i className="fa fa-eye grid-icon" title="View Scope of work"
                                                                    onClick={() => this.updateWorkOrder(data.WorkOrderID, 'view')}
                                                                />
                                                            </a>}
                                                            {data.IsActive && this.getWriteAccess() &&
                                                                <>
                                                                    <span className="mx-1" style={{ color: "#ccc" }}> | </span>
                                                                    <a>
                                                                        <i className="fa fa-pencil grid-icon" title="Update Scope of work"
                                                                            onClick={() => this.updateWorkOrder(data.WorkOrderID, 'update')}
                                                                        />
                                                                    </a>
                                                                    {!isVendor &&
                                                                        <>
                                                                            <span className="mx-1"
                                                                                style={{ color: "#ccc" }}> | </span>
                                                                            <i
                                                                                class="fa fa-clone grid-icon"
                                                                                title="Replicate Scope of work"
                                                                                onClick={() => this.updateWorkOrder(data.WorkOrderID, 'replicate')}
                                                                            />
                                                                            {data.StatusName != "Submitted" &&
                                                                                <>
                                                                                    <span className="mx-2" style={{ color: "#ccc" }}> |</span>
                                                                                    <i className="fa fa-trash text-danger mx-1" title="Delete Scope of work"
                                                                                        onClick={() => this.setState({ isOpen: true, WorkOrderID: data.WorkOrderID, ExhibitionID: data.ExhibitionID })}
                                                                                    />
                                                                                </>
                                                                            }
                                                                        </>
                                                                    }
                                                                </>
                                                            }
                                                        </td>
                                                    </tr>
                                                )) : (<tr><td colSpan={10} className='text-center'>Record not found</td></tr>)
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {!isVendor && <div className="float-left trp p-2"
                                style={{
                                    justifyContent: "space-between"
                                }}>
                                {
                                    workOrderList.length > 0 ?
                                        <Pagination
                                            nPages={nPages}
                                            currentPage={currentPage}
                                            setCurrentPage={this.updateItem}
                                        /> : <></>
                                }
                                <div className="table-record-pages pt-2">
                                    <p>{`${currentPage} of ${nPages} pages`}</p>
                                </div>
                            </div>}
                        </div>

                        {!isVendor &&
                            <>
                                <div class="footer-sec ">
                                    <div class="sdsd">
                                        <strong>Ownership:</strong> All content, formats and images used on this site are owned or licensed by India ITME Society. You may not copy, reproduce, distribute, publish, display, perform, modify, create derivative works, transmit, or in any other way exploit any part of copyrighted material without permission of the copyright owner. Failure to comply shall result in legal action.
                                    </div>
                                </div>
                                <div class="footer-first">
                                    <div class="container-fluid">
                                        <div class="footer-first">  ITME All Rights Reserved <i class="fa fa-copyright" aria-hidden="true"></i> 2023  </div>
                                    </div>
                                </div>
                            </>
                        }

                    </div>
                </div >

                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title modal_title_text">Confirm Delete!</h5>
                                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isOpen: false })} ></button>
                            </div>
                            <div class="modal-body">
                                Do you really want to delete this record?
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e) => this.deleteWorkOrder()}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>

            </>
        )
    }
}
export default withRouter(connect(null, { fill_action, getVendorWorkOrderList_action, deleteVendorWorkOrder_action })(VendorWorkOrderList));